/**
 * Service for area export operations
 */

import { apiClient } from '@/api/core/apiClient';
import { API_CONFIG } from '@/api/core/apiConfig';
import { buildQueryString } from '@/api/shared/queryBuilder';
import type { ApiResponse } from '@/api/shared/types';
import type { AreasExportFilters } from '../types';


export class AreaExportService {
  /**
   * Export areas to Excel file
   * Downloads file directly as Blob
   *
   * Response codes:
   * - 200: Export successful, returns Blob
   * - 400: Invalid filters
   * - 500: Internal server error
   */
  async export(filters?: AreasExportFilters)
    : Promise<ApiResponse<{ blob: Blob; filename: string }>> {
    const queryString = buildQueryString(filters ?? {});
    const endpoint = `${API_CONFIG.ENDPOINTS.ORGANIZATION.EXPORT_AREAS}${queryString}`;

    const response = await apiClient.downloadBlobWithFilename(endpoint, {
      method: 'GET',
    });

    if (response.success && response.data) {
      return response;
    }

    return { ...response, data: null };
  }
}

export const areaExport = new AreaExportService();
